/**
 * Help me cook route — same Camp Chef panel as the browse modal.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CommunityRecipesPageShell } from './CommunityRecipesPageShell';
import { HelpMeCookPanel } from './HelpMeCookPanel';
import './camp-essentials-shell.css';
import './camp-recipes-shell.css';

export function HelpMeCook() {
  const navigate = useNavigate();

  return (
    <CommunityRecipesPageShell
      title="Camp Chef"
      subtitle="Match recipes to what you have on hand"
      testId="camp-recipes-help"
    >
      <div className="camp-chef-embed">
        <HelpMeCookPanel
          onClose={() => navigate('/camp-essentials/recipes')}
          onOpenRecipe={(id) => navigate(`/camp-essentials/recipes/${id}`)}
        />
      </div>
    </CommunityRecipesPageShell>
  );
}
